// apps/frontend/src/menu/webMenu.ts
// Description: 웹 메뉴 데이터 정의

export interface MenuItemType {
  id: string;
  label: string;
  icon?: string;
  path?: string; // 라우팅 경로
  children?: MenuItemType[];
  isActive?: boolean;
  section?: string; // 섹션 라벨 (열림 상태)
  sectionShort?: string; // 섹션 줄임말 (접힘 상태)
  sectionIcon?: string; // 섹션 아이콘 경로
  hasDivider?: boolean; // 섹션 하단에 구분선 표시
}

export const webMenuData: MenuItemType[] = [
  // Main Section (no label)
  {
    id: 'main',
    label: '',
    children: [
      {
        id: 'dashboard-home',
        label: 'menu_dashboard_home',
        icon: '/icons/IconDashboard.svg',
        path: '/',
      },
      {
        id: 'realtime',
        label: 'menu_monitoring_realtime',
        icon: '/icons/IconRealtime.svg',
        path: '/monitoring/realtime',
      },
      {
        id: 'playback',
        label: 'menu_monitoring_playback',
        icon: '/icons/IconPlayback.svg',
        path: '/monitoring/playback',
      },
      {
        id: 'management',
        label: 'menu_management',
        icon: '/icons/IconCompany.svg',
        path: '/management',
      },
      // Admin items (under management)
      {
        id: 'companies',
        label: 'menu_admin_companies',
        icon: '/icons/IconAdmins.svg',
        path: '/admin/companies',
      },
      {
        id: 'allowed-emails',
        label: 'menu_allowed_emails',
        icon: '/icons/IconAdmins.svg',
        path: '/admin/allowed-emails',
      },
      {
        id: 'user-log',
        label: 'menu_user_log',
        icon: '/icons/IconAdmins.svg',
        path: '/admin/user-log',
      },
      {
        id: 'system-status',
        label: 'menu_system_status',
        icon: '/icons/IconAdmins.svg',
        path: '/admin/system-status',
      },
    ],
  },

  // Local Device Section
  {
    id: 'local-device',
    label: 'menu_configurator',
    section: 'Local Device',
    sectionShort: 'Local',
    children: [
      {
        id: 'lite',
        label: 'menu_lite',
        icon: '/icons/IconBelllite.svg',
        path: '/configurator/lite',
      },
      {
        id: 'mini',
        label: 'menu_mini',
        icon: '/icons/IconBellmini.svg',
        path: '/configurator/mini',
      },
      {
        id: 'detaLog',
        label: 'menu_datalog',
        icon: '/icons/IconData.svg',
        path: '/detaLog',
      },
    ],
  },
];
